/**
 * Tracking variables
 */
export let analytics = analyticstracker();

/**
 * History of steps in the application.
 */
export let history = ['garage-locator'];
